export const SCORE_INCREASE = 'SCORE_INCREASE';
export const SCORE_RESET = 'SCORE_RESET';

export const APP_TAB_SET_ACTIVE = 'APP_TAB_SET_ACTIVE';

export const GO_NEXT_LEVEL = 'GO_NEXT_LEVEL';
export const ROUND_END = 'ROUND_END';
export const RESTART_GAME = 'RESTART_GAME';
export const SET_GAMEOVER = 'SET_GAMEOVER';
export const SELECTED_ANSWERS_RESET = 'SELECTED_ANSWERS_RESET';
export const SELECTED_ANSWERS_SET = 'SELECTED_ANSWERS_SET';

export const ERRORS_COUNT_INCREASE = 'ERRORS_COUNT_INCREASE';
export const ERRORS_COUNT_RESET = 'ERRORS_COUNT_RESET';

export const CURRENT_BIRD_INFO_SET = 'CURRENT_BIRD_INFO_SET';
export const CURRENT_BIRD_INFO_RESET = 'CURRENT_BIRD_INFO_RESET';
